<section class="cp-section" [id]="'sec-' + sectionKey" [attr.data-section]="sectionKey">
  <header class="cp-head">
    <h2 class="cp-h2">{{ title }}</h2>
    <p class="cp-section-lead">{{ lead }}</p>
  </header>
  <div class="cp-main">
    <!-- the app's identity, story and facts at the left, its panel at the right -->
    <div class="ap-more" *ngIf="current as app">
      <span class="ap-more-body">
        <span class="ap-more-id">
          <img class="ap-more-icon" [src]="app.icon" alt="" width="88" height="88">
          <span class="ap-more-titles">
            <span class="ap-more-eyebrow">{{ app.eyebrow }}</span>
            <span class="ap-more-name">{{ app.name }}</span>
          </span>
        </span>
        <span class="ap-more-lead">{{ app.lead }}</span>
        <span class="ap-more-text">{{ app.text }}</span>
        <span class="ap-more-facts" *ngIf="app.facts.length"><span *ngFor="let f of app.facts">{{ f }}</span></span>
        <!-- Discover More, Add to cart with its price while the store sells it, then its store or its Coming Soon note -->
        <span class="ap-more-actions">
          <a class="codigrate-button" [routerLink]="app.link"><p>{{ app.cta }}</p></a>
          <ng-container *ngIf="onSale">
            <button type="button" class="codigrate-button" (click)="addToCart()"><p>Add to cart</p></button>
            <span class="ap-more-offer" *ngIf="price as p">
              <span class="ap-more-offer-amount">{{ p }}</span>
              <span class="ap-more-offer-note">One-time purchase</span>
            </span>
          </ng-container>
        </span>
        <span class="ap-more-actions" *ngIf="app.store as store">
          <a class="codigrate-button" [href]="store.url" target="_blank" rel="noopener" (click)="onInstall( store, $event )"><p>{{ store.label }}</p></a>
        </span>
        <span class="ap-more-soon" *ngIf="!app.store && app.soon">{{ app.soon }}</span>
      </span>
      <span class="ap-more-stage">
        <a class="ap-more-shot-link" [routerLink]="app.link" tabindex="-1" aria-hidden="true"><img class="ap-more-shot" [src]="app.shot.src"
           [alt]="app.shot.alt" [width]="app.shot.width" [height]="app.shot.height" decoding="async"></a>
        <!-- the platforms in a dock under the picture, as on the home's boxes -->
        <span class="ap-more-dock" role="group" [attr.aria-label]="app.name + ' platforms'" *ngIf="this.app.variants?.length">
          <button *ngFor="let v of this.app.variants; let i = index" type="button" class="ap-more-pick" [class.on]="i === active"
                  [attr.aria-pressed]="i === active" (click)="pick( i )"><img *ngIf="v.chipLogo" [src]="v.chipLogo" alt="" width="16" height="16">{{ v.chip }}</button>
        </span>
      </span>
    </div>
  </div>
</section>
